import { render, staticRenderFns } from "./dynamicDetails.vue?vue&type=template&id=df90bb9e&"
import script from "./dynamicDetails.vue?vue&type=script&lang=ts&"
export * from "./dynamicDetails.vue?vue&type=script&lang=ts&"
import style0 from "./dynamicDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports